export enum BackupOnboardingRoutesEnum {
  Members = 'members',
  NotificationSettings = 'notification-settings',
  StorageSettings = 'storage-settings',
  Summary = 'summary',
  Details = 'details',
}
